import {
  TransferMechanism,
  CashDirection,
  Address,
  IraContribution,
  IraDistribution,
  WireDetails,
  BeneficiaryDetails
} from '../'

export enum TerminalCashTransferStates {
  RejectedValidationFailed = 'RejectedValidationFailed',
  ReviewPending = 'ReviewPending',
  Approved = 'Approved',
  RejectedUnapproved = 'RejectedUnapproved',
  RejectedFundsNotPosted = 'RejectedFundsNotPosted',
  FundsPosted = 'FundsPosted',
  FailedAtBank = 'FailedAtBank',
  SentToBank = 'SentToBank',
  Completed = 'Completed',
  SendToBankFailed = 'SendToBankFailed',
  RejectedNotSentToBank = 'RejectedNotSentToBank',
  FundsReturned = 'FundsReturned',
  Returned = 'Returned',
  ReturnedWaitingForReversal = 'ReturnedWaitingForReversal',
  Canceled = 'Canceled',
  Postponed = 'Postponed',
  PendingPrinting = 'PendingPrinting',
  Voided = 'Voided',
  StoppedPayment = 'StoppedPayment'
}
export enum RoutingType {
  ABA = 'ABA',
  BIC = 'BIC'
}

export interface AchDetails {
  relationshipId?: string
  memo?: string
}

export interface TransferParty {
  firstName: string
  lastName: string
  address: Address
}

export interface TravelRuleResponse {
  originatingInstitutionName?: string
  originatingInstitutionAccountNumber?: string
  recipientInstitutionName?: string
  recipientInstitutionAccountNumber?: string
  originator?: TransferParty
  recipient?: TransferParty
}

export interface JournalDetails {
  account?: string
  contraAccountId?: string
  travelRuleDetails?: TravelRuleResponse
}

export enum CheckDeliveryMethod {
  STANDARD = 'STANDARD',
  OVERNIGHT = 'OVERNIGHT',
  OVERNIGHT_TO_APEX = 'OVERNIGHT_TO_APEX'
}
export interface CheckDetails {
  deliveryMethod?: CheckDeliveryMethod
  beneficiaryDetails?: BeneficiaryDetails
  memos?: string[]
}
export enum FeeType {
  MANAGEMENT_FEE = 'MANAGEMENT_FEE',
  ADVISORY_FEE = 'ADVISORY_FEE',
  ADMIN_FEE = 'ADMIN_FEE',
  APEX_ADMIN_FEE = 'APEX_ADMIN_FEE',
  EXCHANGE_FEE = 'EXCHANGE_FEE',
  TECH_FEE = 'TECH_FEE',
  PLATFORM_FEE = 'PLATFORM_FEE',
  MARGIN_INTEREST = 'MARGIN_INTEREST',
  INACTIVITY_FEE = 'INACTIVITY_FEE'
}
export interface FeeDetails {
  account?: string
  contraAccount?: string
  accountSideDescription?: string[]
  contraAccountSideDescription?: string[]
  type?: FeeType
}
export enum CreditType {
  FEE_REVERSAL = 'FEE_REVERSAL',
  PROMO_CREDIT = 'PROMO_CREDIT',
  ZEROING_ACCOUNT = 'ZEROING_ACCOUNT'
}
export interface CreditDetails {
  account?: string
  contraAccount?: string
  accountSideDescription?: string[]
  contraAccountSideDescription?: string[]
  type?: CreditType
}
export interface CashJournalDetails {
  account: string
  contraAccountId: string
}

export interface SearchCashTransfersResponsePayload {
  id?: string
  externalId?: string
  method?: TransferMechanism
  direction?: CashDirection
  amount?: number
  initiationTime?: string
  status?: TerminalCashTransferStates
  achDetails?: AchDetails
  journalDetails?: JournalDetails
  wireDetails?: WireDetails
  checkDetails?: CheckDetails
  feeDetails?: FeeDetails
  creditDetails?: CreditDetails
  iraContributionDetails?: IraContribution
  iraDistributionDetails?: IraDistribution
  cashJournalDetails: CashJournalDetails | null
}
